import { useState } from "react";
import { useQuery } from "react-query";

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import Table from "react-bootstrap/Table";

function Subscribers() {
  const [testResult, setTestResult] = useState(null);
  const [testing, setTesting] = useState(false);

  async function sendTestPush() {
    setTesting(true);
    setTestResult(null);
    try {
      const res = await fetch("/.netlify/functions/push-test", { method: "POST" });
      const data = await res.json();
      setTestResult(data);
    } catch (err) {
      setTestResult({ error: err.message });
    }
    setTesting(false);
  }

  const { isLoading, error, data } = useQuery("subscribers", async () => {
    const res = await fetch("/.netlify/functions/push-subscribers");
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  });

  if (isLoading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center p-5">
        <Alert variant="danger">{error.message}</Alert>
      </div>
    );
  }

  return (
    <Row>
      <Col>
        <h2>Push Subscribers ({data.count})</h2>
        <Button
          variant="warning"
          size="sm"
          className="mb-3"
          onClick={sendTestPush}
          disabled={testing || data.count === 0}
        >
          {testing ? "Sending..." : "Send Test Push"}
        </Button>
        {testResult && (
          <Alert variant={testResult.error ? "danger" : "info"} dismissible onClose={() => setTestResult(null)}>
            {testResult.error
              ? `Error: ${testResult.error}`
              : `Sent: ${testResult.sent}, Errors: ${testResult.errors?.length || 0}`}
            {testResult.errors?.length > 0 && (
              <ul className="mb-0 mt-1">
                {testResult.errors.map((e, i) => (
                  <li key={i}>{e.key}: {e.status} - {e.message}</li>
                ))}
              </ul>
            )}
          </Alert>
        )}
        {data.count === 0 ? (
          <p>No subscribers yet.</p>
        ) : (
          <Table striped bordered hover variant="dark" size="sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>Push Service</th>
              </tr>
            </thead>
            <tbody>
              {data.subscribers.map((sub) => (
                <tr key={sub.key}>
                  <td><code>{sub.key}</code></td>
                  <td>{sub.origin}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Col>
    </Row>
  );
}

export default Subscribers;
